import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { TssDashboard } from 'reports/components';

export const TssDashboardPage = () => {
  const { t } = useTranslation();

  const title = t('labelTssDashboard');

  return (
    <PageLayout scrollable title={title}>
      <PageTitle title={title} />
      <TssDashboard />
    </PageLayout>
  );
};
